module.exports = __webpack_public_path__ + "static/articLogo-0267e17d6c0f42a357d8e05df06a4d5e.jpg";